import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { ShieldAlert, ChevronDown, ChevronRight } from "lucide-react";

// Incidentenlog: wat ging er fout, waarom, wat is gefixt en hoe wordt herhaling voorkomen.
export function Incidenten() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(null);
  useEffect(() => { api.get("/beheer/incidenten").then((r) => setItems(r.data || [])).catch((e) => toast.error(formatApiError(e))); }, []);
  return (
    <div className="mb-8 rounded-lg border border-slate-200 bg-white p-5" data-testid="incidenten">
      <h2 className="text-lg font-bold text-slate-900 flex items-center gap-2 mb-1"><ShieldAlert className="h-5 w-5 text-[#1C64B0]" />Incidenten & verbeteracties</h2>
      <p className="text-sm text-slate-500 mb-3">Volledige openheid: per incident wat er fout ging, de oorzaak, de fix en de bouwregel die herhaling voorkomt.</p>
      {[...items].reverse().map((it, i) => (
        <div key={i} className="border-t border-slate-100" data-testid={`incident-${i}`}>
          <button onClick={() => setOpen(open === i ? null : i)} className="flex w-full items-center gap-2 py-2 text-left text-sm font-semibold text-slate-800 hover:text-[#1C64B0]">{open === i ? <ChevronDown className="h-4 w-4" /> : <ChevronRight className="h-4 w-4" />}<span className="text-xs text-slate-400 w-20 shrink-0">{it.datum}</span>{it.titel}</button>
          {open === i && (
            <dl className="mb-3 ml-7 grid grid-cols-[120px_1fr] gap-x-3 gap-y-1 text-sm">
              <dt className="font-semibold text-slate-500">Wat ging fout</dt><dd className="text-slate-700">{it.wat}</dd>
              <dt className="font-semibold text-slate-500">Oorzaak</dt><dd className="text-slate-700">{it.oorzaak}</dd>
              <dt className="font-semibold text-slate-500">Fix</dt><dd className="text-slate-700">{it.fix}</dd>
              <dt className="font-semibold text-emerald-700">Preventie</dt><dd className="text-emerald-800">{it.preventie}</dd>
              <dt className="font-semibold text-slate-500">Status</dt><dd className="text-slate-700">{it.status}</dd>
            </dl>
          )}
        </div>
      ))}
    </div>
  );
}
